/* eslint-disable @typescript-eslint/no-non-null-assertion */
import {
  TrackingPageTypeWithId,
  TrackingPageTypeWithoutId,
  TrackingProductCategory,
} from '../../../types';
import {DetailedPageInfo, TrackingClientState} from './clientState';
import {exists} from './exists';
import {getSourceHistory} from './sourceHistory';

const isDetailedCategoryPage = (
  currentPage: TrackingClientState['currentPage']
): currentPage is DetailedPageInfo =>
  exists(currentPage) &&
  currentPage.type === 'detailed' &&
  (currentPage.page.type === TrackingPageTypeWithId.Category ||
    currentPage.page.type === TrackingPageTypeWithId.CategoryOverview);

const isPrevPageDetailedWithCategoryId = (
  prevPage: DetailedPageInfo | null
): prevPage is DetailedPageInfo =>
  exists(prevPage) &&
  (prevPage.page.type === TrackingPageTypeWithId.Category ||
    prevPage.page.type === TrackingPageTypeWithId.CategoryOverview ||
    prevPage.page.type === TrackingPageTypeWithId.Story ||
    prevPage.page.type === TrackingPageTypeWithId.Idol ||
    prevPage.page.type === TrackingPageTypeWithoutId.IdolOverview ||
    prevPage.page.type === TrackingPageTypeWithId.Brand ||
    prevPage.page.type === TrackingPageTypeWithoutId.BrandOverview ||
    prevPage.page.type === TrackingPageTypeWithId.ODP ||
    prevPage.page.type === TrackingPageTypeWithoutId.OutfitOverview);

export const getCategory = ({
  productCategories,
  state,
}: {
  productCategories: TrackingProductCategory[] | null;
  state: TrackingClientState;
}) => {
  const prevPage = getSourceHistory({index: 1, state});
  const {currentPage} = state;

  if (!currentPage) {
    return {
      id: null,
      path: null,
    };
  }

  if (isDetailedCategoryPage(currentPage)) {
    return {
      path: currentPage.page.path,
      id: currentPage.page.id || null,
    };
  } else if (isPrevPageDetailedWithCategoryId(prevPage)) {
    return {
      path: prevPage.page.path,
      id: prevPage.page.id || null,
    };
  } else if (exists(productCategories) && productCategories.length > 0) {
    return productCategories[productCategories.length - 1]!;
  }

  return {
    id: null,
    path: null,
  };
};

export const getSourceCategory = (
  state: TrackingClientState
): {
  id: null | number;
  path: null | string;
} => {
  const prevPrevPage = getSourceHistory({index: 2, state});

  if (
    exists(prevPrevPage) &&
    (prevPrevPage.page.type === TrackingPageTypeWithId.Story ||
      prevPrevPage.page.type === TrackingPageTypeWithId.Idol ||
      prevPrevPage.page.type === TrackingPageTypeWithoutId.IdolOverview ||
      prevPrevPage.page.type === TrackingPageTypeWithId.Brand ||
      prevPrevPage.page.type === TrackingPageTypeWithoutId.BrandOverview ||
      prevPrevPage.page.type === TrackingPageTypeWithId.ODP ||
      prevPrevPage.page.type === TrackingPageTypeWithoutId.OutfitOverview)
  ) {
    return {
      id: prevPrevPage.page.id || null,
      path: prevPrevPage.page.path,
    };
  }

  return {id: null, path: null};
};
